import { Redirect } from "react-router-dom";
import { useIntl } from "react-intl";
import { ROLE_ESITTELIJA } from "@/modules/constants";
import { Typography } from "@mui/material";
import { ReactElement } from "react";
import { User } from "@/koodistodatanTyypit";

import common from "@/i18n/definitions/common";

const CasAuthenticated = ({
  user
}: {
  user: User;
}): ReactElement => {
  const { formatMessage } = useIntl();

  if (!user) {
    return <p>{formatMessage(common.loginError)}</p>;
  }

  if (user.roles && user.roles[1] === ROLE_ESITTELIJA) {
    return <Redirect to="/" />;
  }

  return (
    <div className="pl-12 m-auto max-w-8xl">
      <Typography component="h2" variant="h2">
        {formatMessage(common.welcome)}
        {", "}
        {sessionStorage.getItem("username")}
      </Typography>
    </div>
  );
};

export default CasAuthenticated;
